// 설문 탭의 "프레일 평가" 카드. 최근 평가의 8문항 질문·답·점수(Q8 평균 걸음수는 2026-10-27 추가 — 옛 평가는 '답변 없음').
//
// 가입 설문(app_user_survey_answer_export)과 저장소가 다르다 — sdss-api 의 sdss_hd.frail_assessment. 평가마다
// 한 줄이고 여기서는 **최신 1건**만 보인다. 90일이 지나면 '재평가 필요' 로 표시한다(앱과 같은 기준).
// 가입 설문처럼 .sds-list 카드 한 장이라 인쇄 영역에도 그대로 들어간다.

import React from 'react';

const FrailAnswersSection = ({ assessment = null, loading = false, error = null }) => (
    <section className="sds-list survey-page__card frail-answers">
        <div className="sds-list__title">
            프레일 평가
            {assessment && (
                <small className="frail-answers__meta">
                    {assessment.assessedAt} 평가
                    {assessment.expired ? ' · 재평가 필요(90일 경과)' : assessment.validUntil ? ` · ${assessment.validUntil}까지 유효` : ''}
                </small>
            )}
        </div>

        {error && <p className="sds-list__empty">프레일 평가를 불러오지 못했습니다.</p>}
        {!error && loading && <p className="sds-list__empty">불러오는 중…</p>}
        {!error && !loading && !assessment && (
            <p className="sds-list__empty">프레일 평가가 아직 작성되지 않았습니다. 앱에서 8문항을 평가하면 여기에 나옵니다.</p>
        )}

        {assessment && assessment.answers.map((answer) => (
            <div key={answer.code} className="sds-list__row page-break-avoid">
                <div className="sds-list__body">
                    <b>{answer.order}. {answer.question}</b>
                    <small>{answer.name}</small>
                </div>
                <div className="sds-list__spacer" />
                <div className={`sds-list__value survey-page__answer${answer.answerText ? '' : ' survey-page__answer--empty'}`}>
                    {answer.answerText || '답변 없음'}
                    {answer.score !== null && answer.score !== undefined && (
                        <span className="frail-answers__score">{answer.score}/{answer.maxScore}점</span>
                    )}
                </div>
            </div>
        ))}

        {assessment && (
            <div className="sds-list__row frail-answers__total">
                <div className="sds-list__body"><b>설문 점수 합계</b><small>프레일 설문 40점 + 활동 설문 {(assessment.surveyMaxScore ?? 55) - 40}점</small></div>
                <div className="sds-list__spacer" />
                <div className="sds-list__value">{assessment.surveyScore ?? '-'}/{assessment.surveyMaxScore ?? 55}점</div>
            </div>
        )}
    </section>
);

export default FrailAnswersSection;
